export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "RiderPersonaMasterImportWorker.5bf4b5f4133a58ea6567.worker.js");
}
